// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { listLineContainerStyles } from "@ces/App/Components/MyListsDetails/ListLineContainer";
import { avoidBreakInsidePrintElement, color, xScreen } from "@ces/XDL/Utilities";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { css } from "styled-components";

listLineContainerStyles.container = {
    css: css`
        display: grid;
        grid-template-columns: 32px 132px minmax(0, 700px) minmax(40px, 1fr) minmax(0, 317px);
        width: 100%;
        background: ${color("common.white")};
        padding: 16px 0;
        ${xScreen("lte", "md")} {
            grid-template-columns: 25px 103px minmax(0, 700px) minmax(40px, 1fr) minmax(0, 317px);
        }
        ${avoidBreakInsidePrintElement}
        @media print {
            margin: 1px 0; // show borders on print
        }
    `,
};

listLineContainerStyles.checbox = {
    css: css`
        grid-column: 1 / 2;
        grid-row: 1 / 6;
        line-height: 16px;
    `,
};

listLineContainerStyles.image = {
    css: css`
        grid-column: 2 / 3;
        grid-row: 1 / 6;
        ${xScreen("lte", "md")} {
            grid-row: 1 / 5;
        }
    `,
};

listLineContainerStyles.description = {
    css: css`
        grid-column: 3 / 4;
        grid-row: 1 / 3;
        display: inline-flex;
        flex-direction: column;
        ${xScreen("lte", "md")} {
            grid-column: 3 / 6;
        }
        @media print {
            grid-column: 3 / 5;
        }
    `,
};

listLineContainerStyles.price = {
    css: css`
        grid-column: 5 / 6;
        grid-row: 1 / 2;
        ${xScreen("lte", "md")} {
            grid-column: 3 / 6;
            grid-row: 4 / 5;
        }
        @media print {
            grid-column: 5 / 6;
            grid-row: 1 / 2;
        }
    `,
};

listLineContainerStyles.actions = {
    css: css`
        grid-column: 5 / 6;
        grid-row: 2 / 3;
        ${xScreen("lte", "md")} {
            grid-column: 1 / 6;
            grid-row: 5 / 6;
            > ${StyledWrapper} {
                max-width: 327px;
            }
        }
        ${xScreen("lt", "sm")} {
            > ${StyledWrapper} {
                max-width: 100%;
            }
        }
        @media print {
            grid-column: 5 / 6;
            grid-row: 2 / 5;
        }
    `,
};

listLineContainerStyles.deleteItem = {
    css: css`
        grid-column: 5 / 6;
        grid-row: 3 / 5;
        ${xScreen("lte", "md")} {
            grid-column: 4 / 6;
            grid-row: 6 / 7;
        }
        @media print {
            grid-column: 1 / 6;
            grid-row: 7 / 8;
        }
    `,
};

listLineContainerStyles.notes = {
    css: css`
        grid-column: 3 / 4;
        grid-row: 3 / 5;
        ${xScreen("lte", "md")} {
            grid-column: 1 / 4;
            grid-row: 6 / 7;
        }
        @media print {
            grid-column: 1 / 6;
            grid-row: 6 / 7;
        }
    `,
};
